import styled from "styled-components";
import {Link} from 'react-router-dom';
import { Colors } from "src/styles/DesignSystem";

export const SidebarContainer = styled.aside `
    position: fixed;
    z-index: 999;
    width: 100%;
    height : 100vh;
    background: #ffffff;

    top: 0;
    left: 0;

    transition: 0.5s ease-in-out;
    opacity: ${({isOpen}) => (isOpen ? '100%' : '0')};
    top: ${({isOpen}) => (isOpen ? '0' : '-150%')};


    @media screen and (min-width: 769px){
        display: none;
    }
`

export const SidebarHeader = styled.header`
    width: 100%;
    height: 75px;
    display:flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    top: 5%;

    img{
        position: absolute;
        top: 7.5%;
        left: 1.5rem;
        width: 45%;
    }
`

export const Icon = styled.div`
    position: absolute;
    top: 25%;
    right: 12.5%;
    background: transparent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;

    svg{
        width: 25px;
        fill: ${Colors.brown};
    }
`
export const SidebarWrapp = styled.div`
    color: #244A6F;
`

export const SidebarMenu = styled.ul`
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-top: 15%;
    padding-left: 7.5%;

    li{
        margin: 1rem 0;
        position: relative;
    }
`;

export const SidebarLink = styled(Link)`
    
    font-size: 1.5rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s ease-in-out;
    font: 1.25rem/1 'Varela Round', arial, sans-serif;
    color: ${Colors.brown};
    cursor: pointer;
    position: relative;

    &:hover,
    .active{
        color: ${Colors.orange};

        &::before{
            content: '';
            height: 75%;
            width: 3px;
            border-radius: 15px;
            background-color: ${Colors.orange};

            position: absolute;
            z-index: 999;
            top: 10%;
            left: -5%;
        }
    }
`;

export const SubNav = styled.ul`
    width: 100%;
    z-index: 99;
    display: none;
    margin-top: 5%;
    margin-left: 5%;

    li{
        margin: 0;
    }

    &.active{
        display: block;
    }

`;

export const SubItem = styled.li`
    padding: .75rem 0;
`;

export const SidebarCtaWrap = styled.div`
    display: flex;
    justify-content: center;
`